import { render, staticRenderFns } from "./WarehouseData.vue?vue&type=template&id=d1594fc4&scoped=true"
import script from "./WarehouseData.vue?vue&type=script&lang=js"
export * from "./WarehouseData.vue?vue&type=script&lang=js"
import style0 from "./WarehouseData.vue?vue&type=style&index=0&id=d1594fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1594fc4",
  null
  
)

export default component.exports